const configState = {
  Roles: [],
  Nations: [],
  Partners: [],
  PartnerEmployees: [],
  Packages: [],
  AddOnFeatures: [],
};

export default configState;